import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  IKeyValue,
  offline,
  online,
  removeCookies,
  removeLocalStorageItem,
  setCookie,
  setCookies,
  setLocalStorageItem,
  tabHidden,
  tabVisible,
} from './browser-manager-data.actions';

@Injectable()
export class BrowserManagerDataDispatcher {
  constructor(private _store: Store<any>) {}

  setLocalStorageItem(key: string, value: string | number | boolean) {
    this._store.dispatch(setLocalStorageItem(key, value));
  }

  removeLocalStorageItem(key: string) {
    this._store.dispatch(removeLocalStorageItem(key));
  }

  setCookie(key: string, value: string) {
    this._store.dispatch(setCookie(key, value));
  }

  setCookies(cookies: IKeyValue[]) {
    this._store.dispatch(setCookies(cookies));
  }

  removeCookies(keys: string[], path?: string, domain?: string) {
    this._store.dispatch(removeCookies(keys, path, domain));
  }

  online() {
    this._store.dispatch(online());
  }

  offline() {
    this._store.dispatch(offline());
  }

  tabVisible() {
    this._store.dispatch(tabVisible());
  }

  tabHidden() {
    this._store.dispatch(tabHidden());
  }
}
